export const SPACE = '\u0020';

export const NON_BREAKING_SPACE = '\u00A0';

export const NON_BREAKING_HYPHEN = '\u2011';
